import './SpiderGraph.css';
import Radar from 'react-d3-radar'
import React, { useState, useEffect } from 'react';

function SpiderGraph(props) {
    const [alphaM1, setAlphaM1] = useState(0);
    const [deltaM1, setDeltaM1] = useState(0);
    const [betaM1, setBetaM1] = useState(0);
    const [gammaM1, setGammaM1] = useState(0);
    const [thetaM1, setThetaM1] = useState(0);

    const [alphaM2, setAlphaM2] = useState(0);
    const [deltaM2, setDeltaM2] = useState(0);
    const [betaM2, setBetaM2] = useState(0);
    const [gammaM2, setGammaM2] = useState(0);
    const [thetaM2, setThetaM2] = useState(0);

    const [museInterval, setMuseInterval] = useState(undefined);

    useEffect(async() => {

        if (museInterval !== undefined)
        {
            await setMuseInterval(clearInterval(museInterval));
        }

        if (props.muse1 === undefined)
        {
            setDeltaM1(0);
            setAlphaM1(0);
            setBetaM1(0);
            setThetaM1(0);
            setGammaM1(0);
        }

        if (props.muse2 === undefined)
        {
            setDeltaM2(0);
            setAlphaM2(0);
            setBetaM2(0);
            setThetaM2(0);
            setGammaM2(0);
        }

        setMuseInterval(setInterval(setAll, 100))

    }, [props.muse1, props.muse2])

    function setAll()
    {
        if (props.muse1 !== undefined)
        {
            setDeltaM1(props.muse1.getDelta())
            setAlphaM1(props.muse1.getAlpha())
            setBetaM1(props.muse1.getBeta())
            setThetaM1(props.muse1.getTheta())
            setGammaM1(props.muse1.getGamma())
        }

        if (props.muse2 !== undefined)
        {
            setDeltaM2(props.muse2.getDelta())
            setAlphaM2(props.muse2.getAlpha())
            setBetaM2(props.muse2.getBeta())
            setThetaM2(props.muse2.getTheta())
            setGammaM2(props.muse2.getGamma())
        }
    }

    return (

        <div id="mBandeau1">
            <Radar
                width={500}
                height={500}
                padding={60}
                domainMax={1}
                highlighted={null}
                onHover={(point) => {
                    if (point) {
                        console.log(point.value);
                    } else {
                        console.log('not over anything');
                    }
                }}
                data={{
                    variables: [
                        {key: 'alpha', label: 'α'},
                        {key: 'delta', label: 'Δ'},
                        {key: 'beta', label: 'β'},
                        {key: 'gamma', label: 'γ'},
                        {key: 'theta', label: 'θ'},
                    ],
                    sets: [
                        {
                            key: 'me',
                            label: 'My Scores',
                            values: {
                                alpha: alphaM1,
                                delta: deltaM1,
                                beta: betaM1,
                                gamma: gammaM1,
                                theta: thetaM1,
                            },
                        },
                        {
                            key: 'everyone',
                            label: 'Everyone',
                            values: {
                                alpha: alphaM2,
                                delta: deltaM2,
                                beta: betaM2,
                                gamma: gammaM2,
                                theta: thetaM2,
                            },
                        },
                    ],
                }}
            />
    </div>
)
}

export default SpiderGraph;